import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const BASE_URL = process.env.REACT_APP_BASE_URL || "https://backend.mystore.education/api";

// Get token from sessionStorage
const getToken = () => {
  const storedUser = localStorage.getItem("loggedUser");
  if (!storedUser) {
    throw new Error('No authentication token found');
  }
  
  const parsedUser = JSON.parse(storedUser);
  const token = parsedUser?.token || parsedUser?.data?.token || parsedUser?.user?.token;
  
  if (!token) {
    throw new Error('No authentication token found');
  }
  
  return token;
};

// Fetch settings
export const fetchSettings = createAsyncThunk(
  'settings/fetchSettings',
  async (_, thunkAPI) => {
    try {
      const token = getToken();
      const response = await axios.get(`${BASE_URL}/dashboard/settings`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      });
      // console.log('Settings API Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Settings API Error:', error);
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

// Update settings
export const updateSettings = createAsyncThunk(
  'settings/updateSettings',
  async (formData, thunkAPI) => {
    try {
      const token = getToken();
      
      // console.log('Sending FormData:', formData); // للتشخيص
      
      const response = await axios.post(`${BASE_URL}/dashboard/settings/update`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        }
      });
      
      // console.log('Update Settings Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Update Settings Error:', error);
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

// Update about image
export const updateAboutImage = createAsyncThunk(
  'settings/updateAboutImage',
  async (imageData, thunkAPI) => {
    try {
      const token = getToken();
      
      const formData = new FormData();
      formData.append('about_image', imageData);
      
      const response = await axios.post(`${BASE_URL}/dashboard/settings/about-image`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        }
      });
      
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

const initialState = {
  settings: null,
  aboutImage: null,
  isLoading: false,
  updateLoading: false,
  error: null,
  success: null,
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch settings
      .addCase(fetchSettings.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSettings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.settings = action.payload.data.settings;
        state.aboutImage = action.payload.data.about_image;
      })
      .addCase(fetchSettings.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || 'حدث خطأ في تحميل الإعدادات';
      })
      
      // Update settings
      .addCase(updateSettings.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(updateSettings.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.success = action.payload.message || 'تم تحديث الإعدادات بنجاح';
        // تحديث البيانات المحلية
        if (action.payload.data && action.payload.data.settings) {
          state.settings = action.payload.data.settings;
        }
        if (action.payload.data && action.payload.data.about_image) {
          state.aboutImage = action.payload.data.about_image;
        }
      })
      .addCase(updateSettings.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload?.message || 'حدث خطأ في تحديث الإعدادات';
      })
      
      // Update about image
      .addCase(updateAboutImage.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
      })
      .addCase(updateAboutImage.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.success = action.payload.message || 'تم تحديث الصورة بنجاح';
        state.aboutImage = action.payload.data.about_image;
      })
      .addCase(updateAboutImage.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload?.message || 'حدث خطأ في تحديث الصورة';
      });
  },
});

export const { clearState } = settingsSlice.actions;
export default settingsSlice.reducer;